import { benchmarkTimezones } from '@vision/ui/services/benchmark-timezones';

export function formatPeriod(key: string, locale: string, timeZone: string, coverage = false) {
  const parts: string[] = JSON.parse(key);
  const dates = coverage ? parts.slice(1) : parts;
  const formatter = new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
    timeZone: benchmarkTimezones[timeZone] || timeZone || 'UTC',
  });
  return dates.map((date) => formatter.format(new Date(date))).join(' – ');
}
